import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  root: {
    borderLeft: theme.spacing(3),
    borderColor: theme.palette.text.light,
    padding: theme.spacing(0),
    margin: theme.spacing(1, 0),
    display: "flex",
    alignItems: ({ textArea }) => (textArea ? "flex-start" : "center"),
    justifyContent: "flex-end"
  },
  labelWrapper: {
    textAlign: "right"
  },
  textFieldWrapper: {
    display: "flex",
    justifyContent: "flex-start"
  },
  helperClass: {
    marginRight: theme.spacing(1)
  }
}));
